import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import * as MainConstants from "../../utils/MainConstants";
import ReCAPTCHA from "react-google-recaptcha";




const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder),
  multilineColor:{
    color:'red'
  }
  
});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  multilineColor:{
    color:'black',
    backgroundColor:'white'
  }
});


class ContactUs extends Component {
  
  state = {
    age: '',
    firstname: '',
    lastname:'',
    email:'',
    comment:'',
    userComment:{},
    captchaValue:"",
  };
  constructor(props) {
    super(props);
    
    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange= this.handleEmailChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.saveVisitorComment = this.saveVisitorComment.bind(this);
    this.handleCaptchaChange= this.handleCaptchaChange.bind(this);
    this.sanitizeInput= this.sanitizeInput.bind(this);
    this.recaptchaRef = React.createRef();
    
    
    
  }
  
  handleCaptchaChange = (value) => {
    this.setState({ captchaValue: value });
  };
  
  componentDidMount() {
    const { isAuthenticated ,updateUserProfileAction} = this.props;
    //isAuthenticated();
    //updateUserProfileAction(this.props.userProfile, this.props.loginData.accessToken);
    updateUserProfileAction(null, this.props.loginData.accessToken);
    //updateAuth();
    // console.log("Farshid the loginData " + this.props.loginData.accessToken)  ;
    
  }
  
  
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  
  handleFirstNameChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));
    
    //this.setState({userComment , {{firstname:event.target.value }});
    // this.setState(Object.assign(this.state.firstname, event.target.value));
  }
  
  handleLastNameChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.lastname, event.target.value));
    this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));
    
  }
  
  handleEmailChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.email,event.target.value));
    this.setState(Object.assign(this.state.userComment,{email:event.target.value}));
    
  }
  handleCommentChange(event) {
    //event.preventDefault();
    let sanitizedValue = this.sanitizeInput(event.target.value);
    this.setState(Object.assign(this.state.userComment,{comment: sanitizedValue}));
    //this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
  }
  
  
  saveVisitorComment(event ){
    const {saveAComment} = this.props;
    var  returnString="";
    var tempLastName =  this.state.userComment.lastname;
    var tempFirstName = this.state.userComment.firstname;
    var tempEmail = this.state.userComment.email;
    var tempComment = this.state.userComment.comment;
    
    
    if((tempFirstName == null) || (tempFirstName.length == 0)){
      alert("Please provide your first name!");
    }else {
      
      if ((tempLastName == null) || (tempLastName.length == 0)) {
        alert("Please provide your last name!");
      }else {
        
        if ((tempEmail == null) || (tempEmail.length == 0)) {
          alert("Please provide your Email!");
        } else {
          
          if ((tempEmail.indexOf("@") == -1)) {
            alert("Please provide proper Email address!");
          }else{
            if ((tempComment == null) || (tempComment.length == 0)) {
              alert("Please provide your comment!");
            }else{
              //Here send the data to the back end.
              
              if (this.state.captchaValue) {
                
                saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment, this.state.captchaValue);
                // To reset reCAPTCHA manually
                this.recaptchaRef.current.reset();
              } else {
                // Handle case where reCAPTCHA is not solved
                console.log('Please complete the reCAPTCHA');
                alert('Please make sure the reCAPTCHA is complete');
              }
              
            }
          }
        }
      }
    }
    
    return returnString;
  }
  /* saveVisitorComment(){
			 const {saveAComment} = this.props;
			 var  returnString="";
			var tempLastName =  this.state.userComment.lastname;
			var tempFirstName = this.state.userComment.firstname;
			var tempEmail = this.state.userComment.email;
			var tempComment = this.state.userComment.comment;
			
		 
			 if((tempFirstName == null) || (tempFirstName.length == 0)){
					 alert("Please provide your first name!");
			 }else {
	 
					 if ((tempLastName == null) || (tempLastName.length == 0)) {
							 alert("Please provide your last name!");
					 }else {
	 
							 if ((tempEmail == null) || (tempEmail.length == 0)) {
									 alert("Please provide your Email!");
							 } else {
			 
									 if ((tempEmail.indexOf("@") == -1)) {
											 alert("Please provide proper Email address!");
									 }else{
											 if ((tempComment == null) || (tempComment.length == 0)) {
													 alert("Please provide your comment!");
											 }else{
													 //Here send the data to the back end.
													 saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);
													 
											 }
									 }
							 }
					 }
			 }
			 
			 return returnString;
	 } */
  /* Orignal which was for testing teh login.
	saveVisitorComment(){
			const { isAuthenticated ,updateUserProfileAction} = this.props;
			//isAuthenticated();
			//updateUserProfileAction();
			updateUserProfileAction(null, this.props.loginData.accessToken);
			let returnString ="not defined";

			if(this.props.userProfile !== undefined){
					returnString= this.props.userProfile.sub;
			}

			let returnString2 ="not defined 2";

			if(this.props.userProfile !== undefined){
					returnString2= this.props.userProfile.nickname;
			}
			alert("hey farshid I  got " +returnString+returnString2);
			return returnString;
	} */
  
  sanitizeInput(value){
    let div1 = document.createElement('div');
    div1.textContent = value;
    return div1.innerHTML;
  };
  
  render() {
    const { classes } = this.props;
    return (
      <div id="contactus" style={{  backgroundColor:"#F2F6F8"  }}>
        
        <Grid container spacing={24}   style={{  }}     >
          
          <Grid   item xs={12} sm={12}    style={{   }}   >
            
            <div  style = {{   backgroundPosition:'center',   paddingTop:50,   paddingRight:10, paddingLeft:30}}  >
              
              <Typography  variant="h3"   style = { { textAlign: 'center', alignSelf: 'center'  , color:'red'}} >
                Contact us
              </Typography>
              <Typography  variant="h5"   style = { { textAlign: 'center', alignSelf: 'center'  ,    color:'red'}}>
                ______________________
              </Typography>
              {/*}
                                                    <h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontWeight:'bold', fontSize:20}} >__________________________ </h6> */}
              
              
              <Grid container spacing={24} style = { {   textAlign: 'center', alignSelf: 'center' }}>
                
                <Grid   item xs={12} sm={12} md={6}  lg={6} xl={6}>
                  <Typography  variant="subtitle1"  style = { { paddingTop:20}}>
                                                            <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:26, color:'black'}}>
                                                                     With {MainConstants.APPLICATION_NAME}&trade;, you save time, money and the environment!


                                                                </span>
                  
                  
                  </Typography>
                  
                  <Typography   variant="subtitle1">
                                                                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:26, color:'black'}}>
                                                                For more information, please contact us:


                                                                </span>
                  </Typography>
                  
                  <Typography  variant="subtitle1">
                                                                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:26, color:'black'}}>
                                                                Email: Support@{MainConstants.APPLICATION_NAME}.com
                                                                    </span>
                  </Typography>
                  {/*}
                                                                        <Typography  variant="subtitle1">
                                                                            <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:26, color:'black'}}>
                                                                        Phone: (617) 939-6086
                                                                          </span>
                                                                        </Typography>
                                                                        */}
                  
                  <Typography  variant="subtitle1">
                                                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:26, color:'black'}}>
                                                                    __________________
                                                                    </span>
                  </Typography>
                
                
                
                
                
                
                
                
                </Grid>
                <Grid   item xs={12} sm={12} md={6}  lg={6} xl={6}   >
                  <div style = { { textAlign: 'center', alignSelf:'center' , borderRadius:'0',
                    borderLeftColor: 'red',
                    backgroundColor:'transparent',color:'black', borderSize:'2',borderRadius:'0', bordered:'true'
                    , fontSize:20}}>
                    <Typography  variant="subtitle1" style = { { paddingTop:20}}>
                                                                                    <span style = { { textAlign: 'center', alignSelf: 'center' , fontSize:26, color:'black'}}>
                                                                                        We would love to hear from you
                                                                                        </span>
                    </Typography>
                    
                    
                    <Grid container spacing={8} style = { { textAlign: 'center', alignSelf: 'center' ,backgroundColor:'transparent'}}>
                      
                      
                      <Grid   item xs={6} sm={6}    >
                        
                        <TextField   variant="filled"  style = { { textAlign: 'center', marginLeft:10,  marginTop:20, alignSelf:'center', color:'white', fontSize:16}} required id="Description-fn" name="firstname"  label="First Name"  fullWidth  InputProps={{ classes: {input: classes.multilineColor } }}  value={this.state.userComment.firstname} onChange={this.handleFirstNameChange}/>
                      </Grid>
                      <Grid   item xs={6} sm={6}    >
                        <TextField  variant="filled"  style = { { textAlign: 'center',    alignSelf:'center', marginLeft:5, marginTop:20, marginRight:10,  color:'white', fontSize:16}} required id="DisplayName" name="lastname"  label="Last Name"  fullWidth   value={this.state.userComment.lastname} InputProps={{ classes: {input: classes.multilineColor } }} onChange={this.handleLastNameChange}/>
                      </Grid>
                      
                      <Grid   item xs={12} sm={12}    >
                        <TextField    variant="filled"  style = { { textAlign: 'center', marginLeft:5,  alignSelf: 'center', color:'white', marginRight:10,  fontSize:16}} required id="Description-email" name="email"  label="Email"  fullWidth    value={this.state.userComment.email} InputProps={{ classes: {input: classes.multilineColor } }} onChange={this.handleEmailChange}/>
                      </Grid>
                      <Grid   item xs={12} sm={12}    >
                        <TextField   rowsMax="6" rows="6" variant="filled"   multiline={true}    className={classes.textField} style = { { textAlign: 'center', alignSelf: 'center', paddingTop:20 , color:'white', fontSize:16}} required id="comment" name="comment"  label="Comment"  fullWidth    InputProps={{ classes: {input: classes.multilineColor } }} value={this.state.userComment.comment} onChange={this.handleCommentChange}/>
                      
                      
                      </Grid>
                      
                      
                      
                      
                      
                      
                      
                      <Grid   item xs={12} sm={12}>
                        <div>
                          <ReCAPTCHA
                            sitekey={MainConstants.RECAPTCHASITEKEY}
                            size="normal"
                            ref={this.recaptchaRef}
                            onChange={this.handleCaptchaChange}
                            style={{ display:'flex', marginBottom:1, marginTop:2, justifyContent:'center', alignItems:'center' }}
                          />
                          
                          <Button
                            size="large"
                            type="button"
                            variant="contained"
                            onClick={this.saveVisitorComment}
                            style={{ backgroundColor:'#D4E0EA', fontSize:20, color:'black', border:'2px solid black', borderRadius:5, textTransform:'none', width:'50%' }}
                          >
                            Submit
                          </Button>
                        </div>
                        
                        {/*<div  >
                          <form onSubmit={this.saveVisitorComment}>
                            
                            <ReCAPTCHA
                              //sitekey="6LdjmQ0rAAAAADU4GZUVtQmSXHSH-EBY11cjrAGx" // Replace with your actual site key
                              sitekey={MainConstants.RECAPTCHASITEKEY }
                              size="normal" // Use "invisible" for reCAPTCHA v3 or "normal" for v2
                              ref={this.recaptchaRef}
                              onChange={this.handleCaptchaChange}
                              badge="bottomright" // Adjust badge position as needed
                              style = {{  display:'flex', marginBottom:1, marginTop:2, justifyContent:'center',  alignItems: 'center', }}  />
                            <Button size="large"  type="submit" variant="contained"   style = { { backgroundColor:'#D4E0EA',fontSize:20, color:'black' ,border: '2px solid', borderSize:5,   borderRadius:5, bordered:'true', borderColor:'black', textTransform:'none', width:'50%'}} >Submit</Button>
                          
                          </form>
                        </div>*/}
                        <br/>
                        <a href="/home"   rel="noreferrer">
                          <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                            &lArr; TowWatch Home
                          </Typography>
                        </a>
                        <br/>
                      </Grid>
                    
                    </Grid>
                  
                  
                  
                  </div>
                
                </Grid>
                {/*}
                                                                <Grid   item xs={1} sm={1} md={1}  lg={1} xl={1} >
                                                                    </Grid>
                                                                    */}
              
              
              </Grid>
            
            
            
            </div>
          
          </Grid>
          <Grid   item xs={12} sm={12}    style={{   }}   >
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <Typography component="h2" variant="body1" style = { { color:'gray'}} >
                Copyright © 2022 Vespaan Inc. All Rights Reserved
              </Typography>
              <a href="/privacy"   rel="noreferrer" style={{paddingLeft:10, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <Typography component="h2" variant="body1" style = { { color:'blue'}} >
                  Privacy Policy
                </Typography>
              </a>
            </div>
          </Grid>
        
        
        
        </Grid>
      </div>
    
    
    );
  }
}

ContactUs.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticatedBool: state.login.isAuthenticatedBool,
    userProfile: state.login.userProfile,
    loginData:state.login.loginData,
    
    //auth:state.login.loginData,
    //CompanyDeleteResponse:state.account.deleteCompanyResp,
    //CompanySaveResponse:state.account.saveCompanyResp,
    //locationsArray:state.location.locationsArray,
    //vcArray:state.videocontroller.vcArray,
    //camerasArray:state.camera.camerasArray,
    //errorCMsg:state.account.errorCMsg,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    //login:login,
    //handleAuthentication:handleAuthentication,
    //isAuthenticated:isAuthenticated,
    updateUserProfileAction:updateUserProfileAction,
    saveAComment:saveAComment,
    //updateAuth:updateAuth,
    
  }, dispatch);
};

//export default withStyles(styles)(AppView);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ContactUs));
//export default withStyles(styles)(ContactUs);
